import { API_CONFIG } from '../config/settings'

export type CheckoutMode = 'partner_redirect' | 'cashfree_modal'

export const DEMO_CHECKOUT_PHONE = '1231230123'

/** Demo account on production uses sandbox modal, not SilverFoil redirect. */
export function isDemoCheckoutPhone(phone?: string | null): boolean {
  const digits = (phone || '').replace(/\D/g, '')
  if (!digits) return false
  if (digits === DEMO_CHECKOUT_PHONE) return true
  if (digits.length > 10 && digits.slice(-10) === DEMO_CHECKOUT_PHONE) return true
  return false
}

/** Production builds use SilverFoil redirect; dev and demo phone use Cashfree modal. */
export function isProductionBuild(): boolean {
  return import.meta.env.PROD
}

export async function getCheckoutMode(phone?: string | null): Promise<CheckoutMode> {
  if (!isProductionBuild() || isDemoCheckoutPhone(phone)) {
    return 'cashfree_modal'
  }
  try {
    const q = phone ? `?phone=${encodeURIComponent(phone)}` : ''
    const res = await fetch(`${API_CONFIG.BASE_URL}/payments/checkout-config${q}`)
    if (res.ok) {
      const data = await res.json()
      if (data.demo_checkout) return 'cashfree_modal'
      return data.checkout_mode === 'partner_redirect' ? 'partner_redirect' : 'cashfree_modal'
    }
  } catch {
    /* fallback */
  }
  return 'partner_redirect'
}

export async function usePartnerRedirectCheckout(phone?: string | null): Promise<boolean> {
  return (await getCheckoutMode(phone)) === 'partner_redirect'
}
